'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndDependent } from '../../Entities/Ind/IndDependent';
import { IndDependentCollection } from '../../Collections/Ind/IndDependentCollection';

export class IndDependentRepository extends CoreRepository {
  public createIndDependent(indId: number, payload: any[]) {
    return this.webAPI.createIndDependent(indId, payload).then((response) => {
      const indDependent = new IndDependent();
      indDependent.hydrate(response);

      return indDependent;
    });
  }

  public removeIndDependent(indId: number, dependentId: number) {
    return this.webAPI.removeIndDependent(indId, dependentId).then((response) => {
      return response;
    });
  }

  public updateIndDependent(indId: number, dependentId: number, payload: any[]) {
    return this.webAPI.updateIndDependent(indId, dependentId, payload).then((response) => {
      return response;
    });
  }
}
